import { render, staticRenderFns } from "./AQueNosDedicamosComponent.vue?vue&type=template&id=3c6fe920&scoped=true"
import script from "./AQueNosDedicamosComponent.vue?vue&type=script&lang=js"
export * from "./AQueNosDedicamosComponent.vue?vue&type=script&lang=js"
import style0 from "./AQueNosDedicamosComponent.vue?vue&type=style&index=0&id=3c6fe920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fe920",
  null
  
)

export default component.exports